import toast, { ToastBar as RHTToastBar, type Toast } from 'react-hot-toast'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { XCloseIcon } from '@/components/ui/icons'

export const ToastBar = ({ t }: { t: Toast }) => {
	return (
		<RHTToastBar
			style={{
				display: 'flex',
				justifyContent: 'flex-start',
				alignItems: 'flex-start',
				gap: '4px',
				padding: '8px'
			}}
			toast={t}
		>
			{({ icon, message }) => (
				<>
					<div className='flex items-center justify-center gap-1'>
						{icon}
						{message}
					</div>
					{t.type !== 'loading' && (
						<ButtonLegacy
							onClick={() => toast.dismiss(t.id)}
							shape='square'
							size='xs'
							type='button'
							variant='tertiary'
						>
							<XCloseIcon />
						</ButtonLegacy>
					)}
				</>
			)}
		</RHTToastBar>
	)
}

ToastBar.displayName = 'Toast'
